import { render, staticRenderFns } from "./Iceberg.vue?vue&type=template&id=442650ce&scoped=true&"
import script from "./Iceberg.vue?vue&type=script&lang=js&"
export * from "./Iceberg.vue?vue&type=script&lang=js&"
import style0 from "./Iceberg.vue?vue&type=style&index=0&id=442650ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442650ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
